
import React, { useState } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import ToggleButton from '@material-ui/lab/ToggleButton';
import Box from '@material-ui/core/Box';
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles({
    menuButton: {
        backgroundColor: '#0C4C35',
        '&:hover': {
          backgroundColor: '#63D764'
        },
        '&.MuiToggleButton-root.Mui-selected': {
          backgroundColor: '#63D764',
          color: '#FFFFFF',
        },
        color: '#FFFFFF',
        marginRight: 4,
        width: 80,
        height: 42,
    }
  });

  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
  }))(Tooltip);


export default function MenuButton(props) {
  const classes = useStyles();
  //const [selected, setSelected] = useState(props.selected);

  const handleChange = () => {
    props.handleChange();
  };

  return (
        <HtmlTooltip title={<React.Fragment>{props.tooltip}</React.Fragment>}>
          <span>
          <ToggleButton value={props.label} disabled={props.disabled} className={classes.menuButton} selected={props.selected} onChange={handleChange}>
              <Box p={1} fontWeight="fontWeightBold" fontSize={12}>{props.label}</Box>
          </ToggleButton>
          </span>
        </HtmlTooltip>
  );
}